<template>
  <div class="device-map ls">
    <vue-amap
      ref="amap"
      :d3-features="['bg', 'road', 'point']"
      :bounds="bounds"
      :zoom="10"
      :center="center"
      @complete="setMarkers"
    ></vue-amap>

    <!-- <chart-amap :geo="geo" /> -->
  </div>
</template>

<script>
import Vue from 'vue'
// import ChartAmap from '@/components/ChartAmap'
import VueAmap from '@/components/Amap/index.vue'
import colors from '@/utlis/colors'

export default {
  components: { VueAmap },
  props: { devKey: String, geo: Object, sites: Array },
  data() {
    return {
      width: 252,
      chart: null
    }
  },
  computed: {
    items() {
      return this.sites.map(d => ({ ...d, icon: { name: 'light' } }))
    },
    bounds() {
      return this.geo && this.geo.features
        ? this.geo.features[0].geometry.coordinates[0][0]
        : []
    },
    center() {
      return this.geo && this.geo.features
        ? this.geo.features[0].properties.center
        : []
    },
    markers() {
      return this.items
        .filter(d => d.center)
        .map((d, idx) => {
          const content = this.getContent(d.icon, d.name, colors[idx])
          const info = this.getInfo(d)
          return { lat: d.center[1], lng: d.center[0], content, info }
        })
    }
  },
  mounted() {
    this.layout()
    this.setMarkers()
  },
  methods: {
    layout() {
      this.width = this.$el.clientWidth
    },
    getContent(icon, name, color) {
      const el = new Vue({
        render(h) {
          const content = h('svg-icon', { props: { iconClass: icon.name } })
          return h(
            'div',
            {
              class: `amap-marker amap-marker__small`,
              style: `color: ${color};`,
              ref: 'node'
            },
            [content]
          )
        }
      }).$mount()
      return el.$refs.node
    },
    getInfo(device) {
      let el = document.createElement('div')
      el.className = 'amap-marker__title'
      el.innerHTML = device.name
      el.onclick = () => {
        this.$emit('change', device)
      }
      return el
    },
    setMarkers() {
      if (this.markers.length && this.$refs.amap) {
        this.$refs.amap.setMarkers(this.markers)
      }
    },
    focusIcon() {
      const el = new Vue({
        render(h) {
          const content = h('svg-icon', { props: { iconClass: 'water-drop' } })
          return h(
            'div',
            {
              class: 'amap-marker amap-marker__small',
              style: `color: #fff;`,
              ref: 'node'
            },
            [content]
          )
        }
      }).$mount()
      return el.$refs.node
    },
    setFocus(key) {
      const index = this.teles.findIndex(t => t.key === key)
      if (index >= 0) {
        const device = this.teles[index]
        this.$refs.amap.setCenter([device.lng, device.lat])
        this.$refs.amap.setFocus(index)
      }
    }
  }
}
</script>

<style lang="scss">
$marker-small: 32px;
$marker-size: 14px; // 图标尺寸
$marker-text-size: 14px;
$marker-text-lineheight: 32px;
$marker-focus-size: 48px;

.device-map.ls {
  background-image: url('~@/assets/images/map-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  // margin-bottom: 40px;
  .amap-container {
    background: transparent !important;
  }
  .amap-logo {
    display: none !important;
  }
  .amap-copyright {
    display: none !important;
  }
  .amap-marker__small {
    display: flex;
    width: $marker-small;
    height: $marker-small;
    border-radius: 50%;
    background: rgba(27, 43, 55, 0.8);
    align-items: center;
    justify-content: center;
  }
  .amap-marker__small.actived {
    transform: scale(1.2);
    border: 1px solid #209e91;
    .svg-icon {
      color: #fff;
    }
  }
  .svg-icon {
    font-size: $marker-size;
    width: $marker-size;
  }
  .amap-marker__title {
    padding-left: 1rem;
    padding-right: 1rem;
    color: #f2f6fc;
    height: $marker-text-lineheight;
    line-height: $marker-text-lineheight;
    font-size: $marker-text-size;
    background-color: #1b2b37;
    border-radius: 3px;
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
